import v4 from 'uuid';
import GeoJSON from 'ol/format/GeoJSON';
import { getLayer } from '../../openlayers-utils/layer-utilities';
//import {replacer} from '../../openlayers-utils/misc';
// import Style from 'ol/style/Style';
// import Fill from 'ol/style/Fill';
// import Stroke from 'ol/style/Stroke';
// import Circle from 'ol/style/Circle';


// import VectorTileSource from 'ol/source/VectorTile';
// import {VectorTile as VectorTileLayer} from 'ol/layer';
// import Projection from 'ol/proj/Projection';
// import geojsonvt from 'geojson-vt';

// var style = new Style({
//   fill: new Fill({
//     color: 'rgba(255, 255, 255, 0.6)'
//   }),
//   stroke: new Stroke({
//     color: '#319FD3',
//     width: 1
//   }),
  
// });


// const replacer = function(key, value) {
//   if (value.geometry) {
//     let type;
//     const rawType = value.type;
//     let geometry = value.geometry;

//     if (rawType === 1) {
//       type = 'MultiPoint';
//       if (geometry.length == 1) {
//         type = 'Point';
//         geometry = geometry[0];
//       }
//     } else if (rawType === 2) {
//       type = 'MultiLineString';
//       if (geometry.length == 1) {
//         type = 'LineString';
//         geometry = geometry[0];
//       }
//     } else if (rawType === 3) {
//       type = 'Polygon';
//       if (geometry.length > 1) {
//         type = 'MultiPolygon';
//         geometry = [geometry];
//       }
//     }

//     return {
//       'type': 'Feature',
//       'geometry': {
//         'type': type,
//         'coordinates': geometry
//       },
//       'properties': value.tags
//     };
//   } else {
//     return value;
//   }
// };

export default {
  name:'addData',

  getReducer(){
    const initialState = {

    }

    return (state = initialState, { type, payload }) => {
      switch(type){
        case 'ADD_DATA_ADDED_GEOJSON':
          return Object.assign({}, state, payload);
        default:
          return state;
      }
    }
  },

  doAddDataGeojson: (filename, json) => ({dispatch, store}) => {
    //console.log(geojson)
    const parentUid = store.selectTreeViewRootId();
    const uid = v4();
    const mapLayer = getLayer({
      serviceType: 'LocalVector',
      visible: true
    });
    const features = (new GeoJSON()).readFeatures(json, {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
    const src = mapLayer.getSource();
    src.addFeatures(features);

    
    store.doGeojsonIdentAddFeatures(uid, json, mapLayer);

    // const tileIndex = geojsonvt(json, {
    //   extent: 4096,
    //   debug: 1
    // });
    // const vectorSource = new VectorTileSource({
    //   format: new GeoJSON({
    //     // Data returned from geojson-vt is in tile pixel units
    //     dataProjection: new Projection({
    //       code: 'TILE_PIXELS',
    //       units: 'tile-pixels',
    //       extent: [0, 0, 4096, 4096]
    //     })
    //   }),
    //   tileUrlFunction: function(tileCoord) {
    //     const data = tileIndex.getTile(tileCoord[0], tileCoord[1], tileCoord[2]);
    //     const geojson = JSON.stringify({
    //       type: 'FeatureCollection',
    //       features: data ? data.features : []
    //     }, replacer);
    //     return 'data:application/json;charset=UTF-8,' + geojson;
    //   }
    // });
    // const mapLayer = getLayer({
    //   serviceType: 'LocalVectorTileLayer',
    //   visible: true
    // },vectorSource);
    store.doAddLayer({
      uid: uid,
      displayName: filename,
      parentUid: parentUid,
      mapLayer: mapLayer,
      serviceType: 'LocalVector',
      visible: true
    })
    store.doSetCursor();
    dispatch({ type: 'ADD_DATA_ADDED_GEOJSON', payload: {key: uid}})
  }
}
